// extracted by mini-css-extract-plugin
module.exports = {"component":"BasicThumbnail_component__aZLDO","placeholder":"BasicThumbnail_placeholder__0eiXY","blur":"BasicThumbnail_blur__nG2a8"};